import './App.css';
import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Contexts/AuthContexts"
import Signup from './Pages/Signup';
//import UserHome from './Pages/UserHome';
import Welcome from "./Pages/Welcome";
import Login from "./Pages/Login";
import PrivateRoute from "./Components/PrivateRoute";
import NewEvent from "./Pages/NewEvent";
import Events from "./Pages/Events";
import EventComponent from "./Components/EventComponent";
import EditEvent from "./Pages/EditEvent";
import Sidebar from "./Components/Sidebar";
import DisplayEvent from './Pages/DisplayEvent';
import EventMap from './Pages/EventMap';
import MyEvents from './Pages/MyEvents';
import {FilterProvider} from "./Contexts/FilterContext"
import {DataProvider} from "./Contexts/DataContext"

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FilterProvider>
          <DataProvider>
                <Routes>
                  <Route path="/" element={<Welcome />} />
                  <Route path="/Signup" element={<Signup />} />
                  <Route path="/Login" element={<Login />} />
                  <Route path="/UserHome" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={0} /><Events /></PrivateRoute></div>} />
                  <Route path="/NewEvent" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={1} /><NewEvent /></PrivateRoute></div>} />
                  <Route path="/EventMap" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={3} /><EventMap /></PrivateRoute></div>} />
                  <Route path="/MyEvents" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={4} /><MyEvents/></PrivateRoute></div>} />
                  {/* <Route path="/Events" element={<PrivateRoute><Events /></PrivateRoute>} /> */}
                  <Route path="/EventComponent" element={<PrivateRoute><EventComponent /></PrivateRoute>} />
                  <Route path="/EditEvent/:eventID" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={0} /><EditEvent /></PrivateRoute></div>} />
                  <Route path="/DisplayEvent/:eventID" element={<div className="flex h-full"><PrivateRoute><Sidebar selectedIndex={0} /><DisplayEvent /></PrivateRoute></div>} />
              </Routes>
          </DataProvider>
        </FilterProvider>
      </AuthProvider>
  </BrowserRouter>
  );
}

export default App;